/**
 *  import * as Libphonenumber from 'libphonenumber-js';
 *  If used above line in typescript, occurs error in unit test
 *  So use js file.
 */
import * as Libphonenumber from 'libphonenumber-js';
export default Libphonenumber;
